import ConfigManager from '@/config/ConfigManager';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Util from "@/helper/Utility.js";
// import TransferPointConfig from './TransferPointConfigManager';


import CategoryModel from '@/core/Campaign/model/CategoryModel';
import DashboardModel from '@/core/Campaign/model/DashboardModel';
import CampaignModel from '@/core/Campaign/model/CampaignModel';
import { ProfileModel } from '@/core/Account/model/AccountModel';
import { map } from 'rxjs/operators';

export default {
    getBaseUrl: function(apiPrefix) {
        var baseUrl = ConfigManager.getApiUrl();
        if (apiPrefix) {
            baseUrl = ConfigManager.getApiUrlWithPrefix();
            baseUrl = baseUrl.replace('{prefix}', apiPrefix);
        }
        return baseUrl;
    },
     /**
      * @param {Object} categoryParam CategoryConfigModel - /core/Campaign/model/CategoryConfigModel.js
      */
    apiGetCategory: function (token, categoryParam, appId, weblandingBlob, jwt) {
        let url = '';
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "category_menu");
        // const url = ConfigManager.getApiUrl() + '/campaigncat/menu';
        return BzbsApi.connectBzbsGetWithAppId(url, token, categoryParam, appId, jwt)
            .pipe(map((res) => {
                var categories = [];
                for (var i of res.data) {
                    var category = new CategoryModel(i);
                    categories.push(category);
                }

                return categories;
            }));
    },

    /**
     * Get custom dashboard
     * @param {object} params (require) SubDashboardConfigModel  - /service/config/DashboardConfigModel.js
     * @return {Pormoise} list of DashboardModel
     */
    apiGetSubDashboard: function (token, params, dashboardName, appId, weblandingBlob, jwt) {
        let url = '';
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "dashboard");
        url = url.replace("{config}", dashboardName)
        // const url = ConfigManager.getApiUrl() + `/dashboard/${dashboardName}`;
        return BzbsApi.connectBzbsGetWithAppId(url, token, params, appId, jwt)
            .pipe(map((res) => {
                var data = res.data;
                if (data instanceof Array) {
                    var listDashboard = [];
                    for (var i of data) {
                        listDashboard.push(new DashboardModel(i));
                    }
                    return listDashboard;
                } else {
                    return null;
                }
            }));
    },

    /**
     * @param {Object} objListConfig (Require) CampaignListConfigModel - /core/Campaign/model/CampaignConfigModel.js
     * @param {Object} objListFilterConfig (Optional) CampaignListFilterConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    //TODO: Revise
    apiGetCampaign: function (token ,objListConfig, objListFilterConfig, appId, weblandingBlob, jwt) {
        var params = objListConfig.getParams();
        if (objListFilterConfig != null) {
            var filter = objListFilterConfig.getParams();
            params = {...params , ...filter};
        }

        let url = '';
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "campaign_list");

        // const url = ConfigManager.getApiUrl() + "/campaign";
        return BzbsApi.connectBzbsGetWithAppId(url, token, params, appId, jwt)
            .pipe(map((res) => {
                var arrCampaign = [];
                for (var i of res.data) {
                    var objCampaign = new CampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                return arrCampaign;
            }));
    },

    /**
     * @param {Object} objDetailConfig (Require) CampaignConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaignDetail: function (token, objDetailConfig, appId, weblandingBlob, jwt) {
        var params = objDetailConfig.getParams();

        let url = '';
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "campaign_list");
        url = url + `/${objDetailConfig.strId}`
        // const url = ConfigManager.getApiUrl() + `/campaign/${objDetailConfig.strId}`;

        return BzbsApi.connectBzbsGetWithAppId(url, token, params, appId, jwt)
            .pipe(map((res) => {
                var campaign = new CampaignModel(res.data);
                return campaign;
            }));
    },

    /**
     * Get user profile.
     */
    // TODO: Revise
    getProfile: function (token, appId, weblandingBlob, jwt) {
        let url = '';
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "profile");

        // const url = ConfigManager.getApiUrl() + '/profile/me';
        return BzbsApi.connectBzbsGetWithAppId(url, token, null, appId, jwt)
            .pipe(map((res) => {
                const profile = new ProfileModel();
                profile.setDataFromApi(res.data);

                const profileData = {
                    profile: profile,
                };

                return profileData;
            }));
    },

    /**
     * Add item(s) to cart.
     * @param {Object} cartParams /core/ShoppingCart/model/AddCartModel.js
     */
    // ไม่ได้ใช้
    apiAddToCart: (token,cartParams, appId, jwt) => {
        let url = ConfigManager.getApiShoppingCartUrl() + '/cart/adds';
        return BzbsApi.connectBzbsPostWithAppId(url, token, cartParams, appId, jwt).pipe(map((res) => {
            return res.data;
        }));
    },

    apiAddItemToCart: (token, cartParams, appId, list, weblandingBlob, jwt) => {
        let url = '';
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "add_to_cart_item", list.id);
        return BzbsApi.connectBzbsPostWithAppId(url, token, cartParams, appId, jwt).pipe(map((res) => {
            return res.data;
        }));
    },

    apiGetInfo: (token, categoryId, appId, jwt) => {
        let url = ConfigManager.getApiUrl() + `/config/${categoryId}`;
        return BzbsApi.connectBzbsGetWithAppId(url, token, null, appId, jwt).pipe(map((res) => {
            return res.data;
        }));
    }
}
